// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__TPLbx","title":"FrontImage_title__2bbrb"};